import Vue from 'vue';
import VueMq from 'vue-mq';
import VueHtmlToPaper from 'vue-html-to-paper';
import InstantSearch from 'vue-instantsearch';
import * as VueGoogleMaps from 'vue2-google-maps';
import GmapCluster from 'vue2-google-maps/dist/components/cluster';

import App from './App.vue';
import BaseCheckbox from '../_base/form/Checkbox.vue';

Vue.use(InstantSearch);
Vue.use(VueHtmlToPaper);

Vue.use(VueGoogleMaps, {
    load: {
        key: window.googleKey,
        libraries: 'places,geometry'
        // map_ids: '3ea2214ddbdab5e2',
        // v: 'beta'
    },
    installComponents: true
});

Vue.use(VueMq, {
    breakpoints: {
        mobile: 768,
        desktop: Infinity
    }
});

Vue.component('GmapCluster', GmapCluster);
Vue.component('BaseCheckbox', BaseCheckbox);

const node = document.querySelector('#provider-search');

if (node) {
    new Vue({
        el: node,

        data: {
            ...node.dataset,
            windowWidth: window.innerWidth
        },

        computed: {
            isMobile() {
                return this.windowWidth <= 768;
            }
        },

        created() {
            window.addEventListener('resize', () => {
                this.windowWidth = window.innerWidth;
            });
        },

        render: (h) => {
            const lat = node.dataset.defaultLat;
            const lng = node.dataset.defaultLng;
            const defaultFiltersPayments = node.dataset.defaultFiltersPayments;
            const defaultFiltersServices = node.dataset.defaultFiltersServices;
            const defaultZoom = node.dataset.defaultZoom
                ? parseInt(node.dataset.defaultZoom)
                : undefined;
            return h(App, {
                props: {
                    defaultExtrasCategory: node.dataset.defaultExtrasCategory || undefined,
                    defaultFiltersPayments:
                        defaultFiltersPayments && JSON.parse(defaultFiltersPayments),
                    defaultFiltersServices:
                        defaultFiltersServices && JSON.parse(defaultFiltersServices),
                    minimalUi: !!node.dataset.minimalUi,
                    hideFiltersUi: !!node.dataset.hideFiltersUi,
                    hideSearchBarUi: !!node.dataset.hideSearchBarUi,
                    hideCategoriesUi: !!node.dataset.hideCategoriesUi,
                    coordinates:
                        lat && lng ? { lat: parseFloat(lat), lng: parseFloat(lng) } : undefined,
                    useGeoLocation: !(node.dataset.useGeoLocation === 'false'),
                    defaultZoom,
                    defaultToListView: !!node.dataset.defaultToListView,
                    viewSwappable: !!node.dataset.viewSwappable,
                    hideWebsiteInListings: !!node.dataset.hideWebsiteInListings,
                    extrasListHeading: node.dataset.extrasListHeading,
                    healthPartnersProvidersOnly: !!node.dataset.healthPartnersProvidersOnly
                }
            });
        }
    });
}
